<script>
import BaseStatusForm from '@/components/base/BaseStatusForm.vue';

export default {
  name: 'BaseStatusEditor',
  components: { BaseStatusForm },
  props: {
    usedColors: {
      type: Array,
      default: () => {},
    },
  },
  methods: {
    async onCreate() {
      const data = await this.$refs.form.open();

      if (!data) return;

      this.$emit('create', { data });
    },
    async onUpdate({ id, name, color }) {
      const data = await this.$refs.form.open(name, color);

      if (!data) return;

      this.$emit('update', { id, data });
    },
    async onRemove({ id, name }) {
      if (!await this.$confirm(`Вы действительно хотите удалить статус [${name}]`)) return;

      this.$emit('remove', { id });
    },
  },
};
</script>

<template lang="pug">
  .status-editor
    BaseStatusForm(ref="form" :usedColors="usedColors")
    slot(
      :onCreate="onCreate"
      :onUpdate="onUpdate"
      :onRemove="onRemove"
    )
</template>

<style scoped lang="scss">

</style>
